module.exports = __webpack_public_path__ + "img/PG2-9-475x323.468a2987.png";